<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.orderNo"
        placeholder="订单号"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.phone"
        placeholder="客户手机号"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.status"
        placeholder="订单状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in statusList"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>

      <DataPicker
        @valueFunc="(type, val) => getPickerValueFunc('order', val)"
        paramsType="create"
        startPlaceholder="下单开始时间"
        endPlaceholder="下单截止时间"
      />

      <DataPicker
        @valueFunc="(type, val) => getPickerValueFunc('receiving', val)"
        paramsType="create"
        startPlaceholder="收货开始时间"
        endPlaceholder="收货截止时间"
      />
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        type="primary"
        v-if="
          (isAgentLogin != AGENT_LOGIN_ROLE_VAL.AGENT || !disabled) &&
            isAgentLogin != AGENT_LOGIN_ROLE_VAL.AGENT_ADMIN
        "
        @click="handleExport"
        >导出</el-button
      >
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column
        label="订单号"
        align="center"
        prop="orderNo"
      ></el-table-column>
      <el-table-column
        label="商品名称"
        align="center"
        prop="goodsNames"
      ></el-table-column>
      <el-table-column
        label="订单金额"
        align="center"
        prop="orderAmount"
      ></el-table-column>
      <el-table-column
        label="分成利润"
        align="center"
        prop="dividendAmount"
      ></el-table-column>
      <el-table-column
        label="TBC奖励"
        align="center"
        prop="tbcNumber"
      ></el-table-column>
      <el-table-column label="订单状态" align="center" prop="orderStatus">
        <template slot-scope="scope">
          {{ getStatus(scope.row.orderStatus) }}
        </template>
      </el-table-column>
      <el-table-column
        label="收货时间"
        align="center"
        prop="receiverTime"
      ></el-table-column>

      <el-table-column
        label="客户手机号"
        align="center"
        prop="customerMobile"
      ></el-table-column>
      <el-table-column
        label="直属上级"
        align="center"
        prop="parentMobile"
      ></el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout=" prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import DataPicker from "@/views/components/dataPicker.vue";
import { uploadXlsx } from "@/utils/index";
import { getLogionUserInfo } from "@/utils/auth";
import { AGENT_LOGIN_ROLE_VAL } from "@/utils/enumUtile";
import {
  getAgentProfitList,
  exportWithdrawApplyList,
} from "@/api/account-profit";
const SHOP_STATUS = [
  {
    key: 0,
    value: "待支付",
  },
  {
    key: 1,
    value: "支付中",
  },
  {
    key: 2,
    value: "待发货",
  },
  {
    key: 3,
    value: "待收货",
  },
  {
    key: 4,
    value: "交易成功",
  },
  {
    key: 5,
    value: "交易关闭",
  },
  {
    key: 6,
    value: "已退款",
  },
  {
    key: 7,
    value: "已退货退款",
  },
  {
    key: 8,
    value: "删除",
  },
];
export default {
  name: "profitSharingOrder",
  props: {
    agentUserId: {
      type: Number || String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: [],
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        pageSize: 10,
        keyword: "",
        status: "",
      },
      statusList: SHOP_STATUS,
      statusMap: new Map(SHOP_STATUS.map((item) => [item.key, item.value])),
      isAgentLogin: "",
    };
  },
  mounted() {
    this.isAgentLogin = getLogionUserInfo().isAgentLogin;
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = false;
      console.log("分润list", this.listQuery);
      this.listQuery.agentUserId = this.agentUserId;
      getAgentProfitList(this.listQuery).then((res) => {
        this.list = res.data.entitys;
        this.total = res.data.totalCount;
        console.log("分润list-1", res, this.list);
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleExport() {
      exportWithdrawApplyList(this.listQuery).then((res) => {
        console.log(res);
        uploadXlsx(res, "账户分润订单表");
      });
    },
    /**
     * 获取时间
     * @param type
     * @param value
     */
    getPickerValueFunc(type, value) {
      if (type === "order") {
        this.listQuery.orderStartTime = value[0];
        this.listQuery.orderEndTime = value[1];
      }
      if (type === "receiving") {
        this.listQuery.deliveryStartTime = value[0];
        this.listQuery.deliveryEndTime = value[1];
      }
    },
    getStatus(key) {
      return this.statusMap.get(key);
    },
  },
  computed: {
    AGENT_LOGIN_ROLE_VAL() {
      return AGENT_LOGIN_ROLE_VAL;
    },
  },
  components: {
    DataPicker,
  },
};
</script>
